import { PageShell } from "./PageShell";
import { Hero } from "./Hero";
import { Marquee } from "./Marquee";
import { Problem } from "./Problem";
import { About } from "./About";
import { VisualManagement } from "./VisualManagement";
import { FinalCTA } from "./FinalCTA";

export default function PlatformPage() {
  return (
    <PageShell testId="platform-page">
      <Hero />
      <Marquee />
      <Problem />
      <About />
      <VisualManagement />
      <FinalCTA />
    </PageShell>
  );
}
